
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"12","cy":"12","r":"10","stroke":"#30373D","stroke-width":"2"}}),_c('path',{attrs:{"d":"M8.6875 9.79865C8.6875 7.88484 10.2721 6.49805 12.0339 6.49805C13.7957 6.49805 15.3085 7.88484 15.3085 9.79865C15.3085 11.2722 14.0904 11.7436 12.9705 12.9815C12.3329 13.6862 12.0339 14.789 12.0339 15.2801M12.0339 16.4998V18.4998","stroke":"#30373D","stroke-width":"2"}})])
          )
        }
      }
    